/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiResponseDefault } from "./api-response-default.interface";

export interface  ApiError extends ApiResponseDefault<any> {
	status?: number;
	message?: string;
}

